
/** Status possibles d'un élément Redux */
export const Status = {
  LOADING: 1,
  OK: 2,
  FAILURE: 3,
  /* Vérifie si un élement est chargé et sans errreurs */
  isLoaded: d => d !== Status.LOADING && d !== Status.FAILURE,
  /* isLoaded + Vérification de l'existence d'un contenu */
  isAvailable: d => d !== undefined && d !== null && Status.isLoaded(d)
};


/** Liste des pays disponibles dans l'application */
export const Countries = [
  'France',
  'Suisse',
  'Italie',
  'Allemagne',
  'Autriche'
];

/** Prefixes téléphoniques pour chaque pays */
export const PhonePrefix = {
  'France': '33',
  'Suisse': '41',
  'Allemagne': '49',
  'Autriche': '43',
  'Italie': '39'
};


/** Constante d'identifiant d'un nouvel élément */
export const NEW_ELEMENT_ID = -1;



// WEBPACK FOOTER //
// ./src/redux/_commons/const.js